<div class="card mb-2 article-card">
  <a
    [routerLink]="['/restaurant', dinings?.slug]"
    class="text-decoration-none text-dark"
  >
    <div class="shadow-sm rounded position-relative">
      <div class="image-wrapper position-relative">
        <img
          [src]="dinings.banners"
          [alt]="dinings.name"
          class="img-fluid rounded"
        />
      </div>

      <!-- Content Box -->
      <div class="text-start content-container">
        <div class="content-inner">
          <div class="content-left">
            <div><span class="dining-type">Pure Veg</span></div>
            <div class="property-title" [title]="dinings.name">
              {{ dinings.name }}
            </div>
            <div class="divider"></div>
            <div class="d-flex align-items-center mb-0 location-text gap-2">
              <i class="fa fa-location-dot location-icon"></i>
              {{ dinings?.destination?.name }}
            </div>
          </div>

          <div class="arrow-btn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 22.955 22.956"
            >
              <path
                id="Path_49088"
                data-name="Path 49088"
                d="M50.4,2.25H40.11a2.64,2.64,0,0,0-1.9.818,2.6,2.6,0,0,0-.716,1.946A2.686,2.686,0,0,0,40.229,7.5H43.37L31.141,19.727a2.624,2.624,0,1,0,3.71,3.711L47.08,11.208v3.141a2.688,2.688,0,0,0,2.484,2.739,2.605,2.605,0,0,0,1.946-.717,2.634,2.634,0,0,0,.818-1.9V4.174A1.926,1.926,0,0,0,50.4,2.25Z"
                transform="translate(-29.874 -1.75)"
                fill="#fff"
                stroke="#fff"
                stroke-width="1"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </a>
</div>
